import { TypeAssignmentCalendar } from '@/pages/workers/pa2-01/pa2-01.config';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetApplicantAssignmentAutocompleteRequest,
	IPayloadGetEnablePublicApplicantsRequest,
	IPayloadGetFranchiseAssignmentAutocompleteRequest,
	IPayloadGetPublicAssignmentSuccess,
	IPayloadPublicListWithDateRequest,
	IPayloadPublicListWithDateSuccess,
	TApplicantAutocompleteDetailStore,
	TEnablePublicApplicantDetailStore,
	TFranchiseAutocompleteDetailStore,
	TPayloadListEnablePublicApplicantSuccess,
	TPublicAssignmentDetailStore,
	TPublicListWithDateStore,
} from './pa2-01-assignment-calendar.type';

const initialState = {
	fetching: false,
	fetchingApplicants: false,
	publicListWithDate: {} as TPublicListWithDateStore,
	param: {
		publicMainFranchiseId: '',
		searchType: TypeAssignmentCalendar.RECRUITER,
		searchValue: '',
		startDate: '',
		endDate: '',
	},
	enablePublicApplicants: {
		content: [] as TEnablePublicApplicantDetailStore[],
		// page: 1,
		// pageSize: 10,
		total: 0,
		fetching: false,
	},
	publicAssignment: {
		content: [] as TPublicAssignmentDetailStore[],
		fetching: false,
	},
	applicantAssignmentAutocomplete: {
		content: [] as TApplicantAutocompleteDetailStore[],
		fetching: false,
	},
	franchiseAssignmentAutocomplete: {
		content: [] as TFranchiseAutocompleteDetailStore[],
		fetching: false,
	},
	publicMainFranchiseId: '',
};

const assignmentCalendarSlice = createSlice({
	initialState,
	name: 'am2_01AssignmentCalendar',
	reducers: {
		/**---- GET PUBLIC LIST WITH DATE START ---- */
		getPublicListWithDateRequest: (
			state,
			action: PayloadAction<IPayloadPublicListWithDateRequest>
		) => {
			state.fetching = true;
			state.publicMainFranchiseId =
				action.payload.params.publicMainFranchiseId || '';
		},
		getPublicListWithDateSuccess: (
			state,
			action: PayloadAction<IPayloadPublicListWithDateSuccess>
		) => {
			state.fetching = false;
			state.publicListWithDate = action.payload.data;
		},
		getPublicListWithDateFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET PUBLIC LIST WITH DATE END ---- */

		/**---- GET ENABLE PUBLIC APPLICANTS START ---- */
		getEnablePublicApplicantsRequest: (
			state,
			action: PayloadAction<IPayloadGetEnablePublicApplicantsRequest>
		) => {
			state.enablePublicApplicants.fetching = true;
		},
		getEnablePublicApplicantsSuccess: (
			state,
			action: PayloadAction<TPayloadListEnablePublicApplicantSuccess>
		) => {
			state.enablePublicApplicants.fetching = false;
			state.enablePublicApplicants.content = action.payload.content;
			state.enablePublicApplicants.total = action.payload.total;
		},
		getEnablePublicApplicantsFailure: (state) => {
			state.enablePublicApplicants.fetching = false;
		},
		/**---- GET ENABLE PUBLIC APPLICANTS END ---- */

		/**---- GET PUBLIC ASSIGNMENT START ---- */
		getPublicAssignmentRequest: (
			state,
			action: PayloadAction<IPayloadPublicListWithDateRequest>
		) => {
			state.publicAssignment.fetching = true;
		},
		getPublicAssignmentSuccess: (
			state,
			action: PayloadAction<IPayloadGetPublicAssignmentSuccess>
		) => {
			state.publicAssignment.fetching = false;
			state.publicAssignment.content = action.payload.assignments;
		},
		getPublicAssignmentFailure: (state) => {
			state.publicAssignment.fetching = false;
		},
		/**---- GET PUBLIC ASSIGNMENT END ---- */

		/**---- GET APPLICANT ASSIGNMENT AUTOCOMPLETE START ---- */
		getApplicantAssignmentAutocompleteRequest: (
			state,
			action: PayloadAction<IPayloadGetApplicantAssignmentAutocompleteRequest>
		) => {
			state.applicantAssignmentAutocomplete.fetching = true;
		},
		getApplicantAssignmentAutocompleteSuccess: (
			state,
			action: PayloadAction<TApplicantAutocompleteDetailStore[]>
		) => {
			state.applicantAssignmentAutocomplete.fetching = false;
			state.applicantAssignmentAutocomplete.content = action.payload;
		},
		getApplicantAssignmentAutocompleteFailure: (state) => {
			state.applicantAssignmentAutocomplete.fetching = false;
		},
		/**---- GET APPLICANT ASSIGNMENT AUTOCOMPLETE END ---- */

		/**---- GET FRANCHISE ASSIGNMENT AUTOCOMPLETE START ---- */
		getFranchiseAssignmentAutocompleteRequest: (
			state,
			action: PayloadAction<IPayloadGetFranchiseAssignmentAutocompleteRequest>
		) => {
			state.franchiseAssignmentAutocomplete.fetching = true;
		},
		getFranchiseAssignmentAutocompleteSuccess: (
			state,
			action: PayloadAction<TFranchiseAutocompleteDetailStore[]>
		) => {
			state.franchiseAssignmentAutocomplete.fetching = false;
			state.franchiseAssignmentAutocomplete.content = action.payload;
		},
		getFranchiseAssignmentAutocompleteFailure: (state) => {
			state.franchiseAssignmentAutocomplete.fetching = false;
		},
		/**---- GET FRANCHISE ASSIGNMENT AUTOCOMPLETE END ---- */
	},
});

export const assignmentCalendarSelectors = {
	selectFetching: (state: RootState) => state.am2_01AssignmentCalendar.fetching,
	selectParamCalendar: (state: RootState) =>
		state.am2_01AssignmentCalendar.param,
	selectPublicListWithDate: (state: RootState) =>
		state.am2_01AssignmentCalendar.publicListWithDate,
	selectEnablePublicApplicants: (state: RootState) =>
		state.am2_01AssignmentCalendar.enablePublicApplicants,
	selectFetchingListEnablePublicApplicants: (state: RootState) =>
		state.am2_01AssignmentCalendar.fetchingApplicants,
	selectPublicAssignment: (state: RootState) =>
		state.am2_01AssignmentCalendar.publicAssignment,
	selectApplicantAssignmentAutocomplete: (state: RootState) =>
		state.am2_01AssignmentCalendar.applicantAssignmentAutocomplete.content,
	selectFranchiseAssignmentAutocomplete: (state: RootState) =>
		state.am2_01AssignmentCalendar.franchiseAssignmentAutocomplete.content,
	selectPublicMainFranchiseId: (state: RootState) =>
		state.am2_01AssignmentCalendar.publicMainFranchiseId,
};

export const AssignmentCalendarActions = assignmentCalendarSlice.actions;
export const AssignmentCalendarReducer = assignmentCalendarSlice.reducer;
